import {
  useDisclosure,
  Box,
  Drawer,
  DrawerOverlay,
  DrawerBody,
  DrawerContent,
  DrawerHeader,
  DrawerCloseButton,
  DarkMode,
} from "@chakra-ui/react";
import React from "react";
import { useCurrentAccountStore } from "../../../store/currentAccountStore";
import { useQueryGetAccounts } from "../../../store/useQueryGetAccounts";
import { AccountSwitcher } from "./AccountSwitcher";
import { CurrentAccountButton } from "./CurrentAccountButton";

export function DrawerAccountNav() {
  const queryGetAccounts = useQueryGetAccounts();
  const accountId = useCurrentAccountStore(({ accountId }) => accountId);
  const currentAccount = queryGetAccounts.data?.accounts[accountId];

  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <Box w="full" py={1}>
        <CurrentAccountButton
          currentAccount={currentAccount}
          isCollapsed={false}
          onClick={onOpen}
        />
      </Box>

      <DarkMode>
        <Drawer placement="left" isOpen={isOpen} onClose={onClose}>
          <DrawerOverlay />

          <DrawerContent>
            <DrawerCloseButton color="gray.50" />

            <DrawerHeader backgroundColor="gray.900" color="gray.50">
              Switch account
            </DrawerHeader>

            <DrawerBody p={0} backgroundColor="white">
              <AccountSwitcher
                accounts={queryGetAccounts.data?.accounts}
                currentAccountId={accountId}
              />
            </DrawerBody>
          </DrawerContent>
        </Drawer>
      </DarkMode>
    </>
  );
}
